import { Suspense, lazy, useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";
import moment from "moment";
import { useSnackbar } from "notistack";
import HeaderAuth from "../../components/HeaderAuth";
import "moment/locale/pt-br";
import { Fab, makeStyles } from "@material-ui/core";
import { RiWhatsappLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import { Constants } from "../../utils/Constants";

moment.locale("pt-br");

const CartaoPage = lazy(() => import("./cartao/CartaoPage"));
const ContaBancariaPage = lazy(() => import("./conta-bancaria/ContaBancariaPage"));
const InicioPage = lazy(() => import("./inicio/InicioPage"));
const InsightsPage = lazy(() => import("./insights-inteligentes/InsightsPage"));
const MinhaContaPage = lazy(() => import("./minha-conta/MinhaContaPage"));
const TagCategoriaPage = lazy(() => import("./tag-categoria/TagCategoriaPage"));
const TransacaoPage = lazy(() => import("./transacao/TransacaoPage"));

const useStyles = makeStyles((theme) => ({
    fab: {
        backgroundColor: "#0d9f0a",
        position: "fixed",
        bottom: 16,
        right: 16,
        color: "#FFF",
        "&:hover": {
            backgroundColor: "#3ebf3c",
        },
    },
}));

export default function HomePage() {
    const { pathname } = useLocation();
    const { closeSnackbar } = useSnackbar();

    const classes = useStyles();

    useEffect(() => {
        closeSnackbar();
    }, [pathname, closeSnackbar]);

    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <HeaderAuth />

            <Switch>
                {<Redirect exact from="/" to="/inicio" />}

                <Route path="/inicio" component={InicioPage} />

                <Route path="/minha-conta" component={MinhaContaPage} />
                <Route path="/tags-categorias" component={TagCategoriaPage} />
                <Route path="/cartoes" component={CartaoPage} />
                <Route path="/contas-bancarias" component={ContaBancariaPage} />
                <Route path="/transacoes" component={TransacaoPage} />
                <Route path="/insights-inteligentes" component={InsightsPage} />

                <Redirect from="/esqueceu-senha" to="/" />
                <Redirect from="/esqueceu-senha-codigo" to="/" />
                <Redirect from="/alterar-senha" to="/" />
                <Redirect from="/signin" to="/" />
                <Redirect from="/auth/login" to="/" />
                <Redirect from="/login" to="/" />

                <Redirect to="/error/error-v6" />
            </Switch>

            <Fab className={classes.fab} title="Conversar com minha Assistente SUR.IA">
                <a href={`https://wa.me/${Constants.numeroWhatsapp}`} target="_blank" rel="noopener noreferrer">
                    <RiWhatsappLine size={28} color="#FFF" />
                </a>
            </Fab>
        </Suspense>
    );
}
